var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowsRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.385 6.146a.437.437 0 0 1 .653 0l5.077 5.5a.53.53 0 0 1 0 .707l-5.077 5.5a.437.437 0 0 1-.653 0 .53.53 0 0 1 0-.707L14.135 12l-4.75-5.147a.53.53 0 0 1 0-.707"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowsRight);
export default ForwardRef;